<template>
  <div>
    <div>
      <searchCpn
        :cpnName="showText"
        :cpnShow="true"
        @handleQuery="handleQuery"
      />
    </div>
    <div class="trendTypeFlex">
      <div class="trendType">
        <div
          class="trendIcon"
          :style="{ background: trendType == 1 ? '#2A7AFF' : 'white' }"
          @click="trendTypeClick(1, trendType)"
        >
          <img
            src="@/assets/images/icon_chart.png"
            style="height: 22px; width: 22px"
            v-if="trendType == 1"
          />
          <img
            src="@/assets/images/icon_chart1.png"
            style="height: 22px; width: 22px"
            v-if="trendType == 2"
          />
        </div>
        <div
          class="trendIcon1"
          :style="{ background: trendType == 2 ? '#2A7AFF' : 'white' }"
          @click="trendTypeClick(2, trendType)"
        >
          <img
            src="@/assets/images/icon_date.png"
            style="height: 22px; width: 22px"
            v-if="trendType == 1"
          />
          <img
            src="@/assets/images/icon_date1.png"
            style="height: 22px; width: 22px"
            v-if="trendType == 2"
          />
        </div>
      </div>
    </div>
    <div v-show="trendType == 1">
      <el-row :gutter="10">
        <el-col :span="12">
          <div class="boardsContain">
            <div class="contaiTitle">{{$t('fuelEfficientDriving.节油驾驶评分趋势')}}</div>
            <div id="chartScore" style="height: 400px"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="boardsContain">
            <div class="contaiTitle">{{$t('fuelEfficientDriving.节油驾驶等级趋势')}}</div>
            <div id="chartLevel" style="height: 400px"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-show="trendType == 2">
      <el-row :gutter="10">
        <el-col :span="12">
          <div class="boardsContain">
            <div class="contaiTitle">{{$t('fuelEfficientDriving.节油驾驶评分趋势')}}</div>
            <div style="margin-top:8px;">
              <div class="dateRow">
                <span class="dateGridOne">{{$t('fuelEfficientDriving.日')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.一')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.二')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.三')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.四')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.五')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.六')}}</span>
              </div>
              <div class="dateRow dateContain">
                <div v-for="indexBlank in blankNum" :key="'blank-' + indexBlank" class="dateGridOne"></div>
                <div v-for="indexMonth in monthNum" :key="'month-' + indexMonth">
                  <div class="dateNum" :style="{'background': heightLightData[indexMonth]?heightLightData[indexMonth].backgroundColor:''}">
                    <div>{{indexMonth}}</div>
                    <div class="gridBottomText" :style="{'color': heightLightData[indexMonth]?heightLightData[indexMonth].color:''}" v-if="heightLightData[indexMonth]">
                      {{heightLightData[indexMonth].score}}
                    <!-- <span v-else>{{heightLightData[indexMonth].level}}</span> -->
                    </div>
                  </div>
                </div>
                <div v-for="indexExtra in extraNum" :key="'extra-' + indexExtra">
                  <div class="dateNum" :style="{'background': extraHeightLightData[indexExtra]?extraHeightLightData[indexExtra].backgroundColor:''}">
                    <div>{{indexExtra}}</div>
                    <div class="gridBottomText" :style="{'color': extraHeightLightData[indexExtra]?extraHeightLightData[indexExtra].color:''}" v-if="extraHeightLightData[indexExtra]">
                        {{extraHeightLightData[indexExtra].score}}
                      <!-- <div v-else>{{extraHeightLightData[indexExtra].level}}</div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="boardsContain">
            <div class="contaiTitle">{{$t('fuelEfficientDriving.节油驾驶等级趋势')}}</div>
            <div style="margin-top:8px;">
              <div class="dateRow">
                <span class="dateGridOne">{{$t('fuelEfficientDriving.日')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.一')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.二')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.三')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.四')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.五')}}</span>
                <span class="dateGridOne">{{$t('fuelEfficientDriving.六')}}</span>
              </div>
              <div class="dateRow dateContain">
                <div v-for="indexBlank in blankNum" :key="'blank1-' + indexBlank" class="dateGridOne"></div>
                <div v-for="indexMonth in monthNum" :key="'month1-' + indexMonth">
                  <div class="dateNum" :style="{'background': heightLightData[indexMonth]?heightLightData[indexMonth].backgroundColor:''}">
                    <div>{{indexMonth}}</div>
                    <div class="gridBottomText" 
                      :style="{'color': heightLightData[indexMonth]?heightLightData[indexMonth].color:'','font-size':LanguageId !=1? '12px':null}" 
                      v-if="heightLightData[indexMonth]">
                    <!-- <span >{{heightLightData[indexMonth].score}}</span> -->
                    {{getText(heightLightData[indexMonth].score)}}
                    </div>
                  </div>
                </div>
                <div v-for="indexExtra in extraNum" :key="'extra1-' + indexExtra">
                  <div class="dateNum" :style="{'background': extraHeightLightData[indexExtra]?extraHeightLightData[indexExtra].backgroundColor:'','font-size':LanguageId !=1? '12px':null}">
                    <div>{{indexExtra}}</div>
                    <div class="gridBottomText" 
                      :style="{'color': extraHeightLightData[indexExtra]?extraHeightLightData[indexExtra].color:''}" 
                      v-if="extraHeightLightData[indexExtra]">
                      <!-- <div>{{extraHeightLightData[indexExtra].score}}</div> -->
                      {{getText(extraHeightLightData[indexExtra].score)}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import searchCpn from "@/views/driver/fuel_efficient_driving/components/searchCpn.vue";
// import * as echarts from "echarts";
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
export default {
  components: { searchCpn },
  props: {
    cpnName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      LanguageId:1,
      trendType: 1,
      chartScore: undefined,
      chartLevel: undefined,
      beginDate: undefined,
      endDate: undefined,
      vehicles: "",
      vehicleName: "",
      showText: {
        title: "参评企业:",
        text: "",
      },
      monthNum:0,
      blankNum:0,
      extraNum:0,
      heightLightData:{},
      extraHeightLightData:[],
    };
  },
  computed: {
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
    }),
  },
  watch: {
    cpnName(newVal, oldVal) {
      this.showText.text = this.cpnName;
    },
  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale)
    this.searchType = this.$t('time.day');
    this.showText.title = this.$t('fuelEfficientDriving.参评企业')+':';
    this.$nextTick(() => {
      this.initChart();
      this.chartScoreSet();
      this.setResize();
    });
    window.addEventListener("resize", this.setResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  deactivated(){
    window.removeEventListener('resize', this.setResize)
  },
  methods: {
    // 更新空格数量跟月份天数
    updateNum(year,month,sameMonth){
      this.blankNum = this.getFirstDayOfMonth(year,month);
      this.monthNum = this.getDaysInMonth(year,month);
      if(sameMonth){
        this.extraNum = 0;
      }else{
        // 查询日期范围不在同一个月
        this.extraNum = Number(this.endDate.split('-')[2]);
      }
    },
    // 获取某个月的总天数
    getDaysInMonth(year, month) {
      // 创建次月第一天的日期（month + 1），日期设为 0
      // 日期设为 0 会自动返回上个月的最后一天
      return new Date(year, month, 0).getDate();
    },
    // 获取某个月的第一天是星期几
    getFirstDayOfMonth(year, month) {
      // Date 对象的月份是从 0 开始的（0 表示 1 月）
      const date = new Date(year, month - 1, 1);
      // 返回一个 0（星期日）到 6（星期六）之间的整数，表示日期是星期几
      return date.getDay();
    },
    trendTypeClick(val, oldVal) {
      this.trendType = val;
      if (val != oldVal && val == 1) {
        this.$nextTick(() => {
          this.setResize();
        });
      }
    },
    getBackColor(score){
      if(score<=100 && score >= 90){
        return "#d8eed0";
      }else if(score < 90 && score >= 80){
        return "#ceeaf9";
      }else if(score < 80 && score >= 70){
        return "#fde5ce";
      }else if(score < 70 && score >= 60){
        return "#f8eecc";
      }else if(score < 60 && score >0){
        return "#fcd3d3";
      }else{
        return "#F1F1F1";
      }
    },
    getTextColor(score){
      if(score<=100 && score >= 90){
        return "#3CAA16";
      }else if(score < 90 && score >= 80){
        return "#0C96E3";
      }else if(score < 80 && score >= 70){
        return "#F37E08";
      }else if(score < 70 && score >= 60){
        return "#DDAC00";
      }else if(score < 60 && score >0){
        return "#EF2424";
      }else{
        return "#F1F1F1";
      }
    },
    getText(score){
      if(score<=100 && score >= 90){
        return this.$t('fuelEfficientDriving.优秀');
      }else if(score < 90 && score >= 80){
        return this.$t('fuelEfficientDriving.良好');
      }else if(score < 80 && score >= 70){
        return this.$t('fuelEfficientDriving.中等');
      }else if(score < 70 && score >= 60){
        return this.$t('fuelEfficientDriving.一般');
      }else if(score < 60 && score >0){
        return this.$t('fuelEfficientDriving.差');
      }else{
        return this.$t('fuelEfficientDriving.差');
      }
    },
    getSelectedVehicles() {
      this.vehicles = "";
      this.vehicleName = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles =
            this.vehicles + this.selectedVehicles[k].nodeValue + ",";
          this.vehicleName =
            this.vehicleName + this.selectedVehicles[k].vehicleName + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    handleQuery(val) {
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      this.vehicles = this.getSelectedVehicles();
      if (this.vehicles.indexOf(",") > -1) {
        this.$message({
          message: this.$t("vehicletrack.selectmorevehicle"),
          type: "warning",
        });
        return false;
      }
      if (this.vehicles == "") {
        this.showText.title = this.$t('fuelEfficientDriving.参评企业')+":";
        this.showText.text = this.cpnName;
      } else {
        this.vehicleName = this.vehicleName.substring(
          0,
          this.vehicleName.length - 1
        );
        this.showText.title = this.$t('fuelEfficientDriving.参评车辆')+":";
        this.showText.text = this.vehicleName;
      }
      const sameMonth = this.beginDate.split('-')[1] == this.endDate.split('-')[1];
      this.$nextTick(() => {
        this.updateNum(this.beginDate.split("-")[0],this.endDate.split("-")[1],sameMonth);
      });
      this.getData();
    },
    getData() {
      this.$api
        .queryFuelEffiGradeScoreTrend({
          OperatorID: this.$store.getters.operator.OperatorId + "",
          BeginDate: this.beginDate,
          EndDate: this.endDate,
          VehicleID: this.vehicles,
        })
        .then((res) => {
          let scoreData = res.data.ScoreData;
          let itemArray = {};
          let extraArray = {};
          // 日历形式数据
          scoreData.forEach((element)=>{
            let _month = element.TheDate.split('-')[1];
            let _day =  Number(element.TheDate.split('-')[2]);
            if(_month == this.beginDate.split('-')[1]){
              itemArray[_day] = {
                num: _day,
                score: element.Score,
                level: element.RankName,
                backgroundColor: this.getBackColor(element.Score),
                color: this.getTextColor(element.Score),
              }
            }else{
              extraArray[_day] = {
                num: _day,
                score: element.Score,
                level: element.RankName,
                backgroundColor: this.getBackColor(element.Score),
                color: this.getTextColor(element.Score),
              }
            }
          });
          // console.log(itemArray,extraArray);
          this.heightLightData = itemArray;
          this.extraHeightLightData = extraArray;

          let dataX1 = [];
          let dataY1 = [[], []];
          let dataX2 = [];
          let dataY2 = [];
          if (res.data) {
            res.data.OilConsumeData.forEach((element) => {
              dataX1.push(element.TheDate);
              dataY1[0].push(element.OilConsume);
            });
            res.data.ScoreData.forEach((element) => {
              dataY1[1].push(element.Score);
            });

            if (this.vehicles != "") {
              dataY2 = [];
              res.data.RankNameData.forEach((element) => {
                dataX2.push(element.TheDate);
                if (element.Excellent > 0) {
                  dataY2.push(100);
                } else if (element.Good > 0) {
                  dataY2.push(80);
                } else if (element.Average > 0) {
                  dataY2.push(60);
                } else if (element.Fair > 0) {
                  dataY2.push(40);
                } else if (element.Poor > 0) {
                  dataY2.push(20);
                }
              });
            } else {
              dataY2 = [[], [], [], [], []];
              res.data.RankNameData.forEach((element) => {
                dataX2.push(element.TheDate);
                dataY2[0].push(element.Excellent);
                dataY2[1].push(element.Good);
                dataY2[2].push(element.Average);
                dataY2[3].push(element.Fair);
                dataY2[4].push(element.Poor);
              });
            }
          }
          this.chartScoreSet(dataX1, dataY1);
          this.chartLevelSet(dataX2, dataY2);
        });
    },
    initChart() {
      this.chartScore = echarts.init(document.getElementById("chartScore"));
      this.chartLevel = echarts.init(document.getElementById("chartLevel"));
    },
    chartLevelSet(dataX, dataY) {
      var option;
      let isSingleCar = Array.isArray(dataY[0]);
      if (!isSingleCar) {
        option = {
          grid: {
            left: 35,
            right: 0,
            bottom: 0,
            top: 55,
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          xAxis: [
            {
              type: "category",
              data: dataX ? dataX : [], //速度
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: {
            axisLine: {
              show: false, // 隐藏Y轴的轴线（竖线）
            },
            axisLabel: { show: false }, // 隐藏Y轴标签文字
          },
          series: [
            {
              type: "line",
              data: dataY ? dataY : [],
              color: "transparent",
              tooltip: {
                valueFormatter: (value) => {
                  if (value == 100) {
                    return this.$t('fuelEfficientDriving.优秀'); // 大于200的点用红色
                  } else if (value == 80) {
                    return this.$t('fuelEfficientDriving.良好'); // 150-200之间用橙色
                  } else if (value == 60) {
                    return this.$t('fuelEfficientDriving.中等'); // 150-200之间用橙色
                  } else if (value == 40) {
                    return this.$t('fuelEfficientDriving.一般'); // 150-200之间用橙色
                  } else if (value == 20) {
                    return this.$t('fuelEfficientDriving.差'); // 150-200之间用橙色
                  } else return " ";
                },
              },
              itemStyle: {
                color: function (params) {
                  // console.log(params.data); // 打印当前点的数据
                  if (params.data == 100) {
                    return "#3CAA16"; // 大于200的点用红色
                  } else if (params.data == 80) {
                    return "#0C96E3"; // 150-200之间用橙色
                  } else if (params.data == 60) {
                    return "#DDAC00"; // 150-200之间用橙色
                  } else if (params.data == 40) {
                    return "#F37E08"; // 150-200之间用橙色
                  } else if (params.data == 20) {
                    return "#EF2424"; // 150-200之间用橙色
                  } else return "#EF2424";
                },
              },
            },
          ],
        };
      } else {
        option = {
          grid: {
            left: 35,
            right: 0,
            bottom: 0,
            top: 55,
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            data: [
              this.$t('fuelEfficientDriving.优秀'), 
              this.$t('fuelEfficientDriving.良好'), 
              this.$t('fuelEfficientDriving.中等'), 
              this.$t('fuelEfficientDriving.一般'), 
              this.$t('fuelEfficientDriving.差')
            ],
            // data: [this.$t("statistics.accumulatedMileage"), this.$t("statistics.accumulatedDuration")]
          },
          xAxis: [
            {
              type: "category",
              data: dataX ? dataX : [], //速度
              axisPointer: {
                type: "shadow",
              },
              axisTick: {
                alignWithLabel: true,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: this.$t('fuelEfficientDriving.评分等级数量(个)'),
            },
          ],
          series: [
            {
              name: this.$t('fuelEfficientDriving.优秀'),
              type: "line",
              smooth: true,
              color: "#36AC00",
              data: dataY ? dataY[0] : [],
            },
            {
              name: this.$t('fuelEfficientDriving.良好'),
              type: "line",
              smooth: true,
              color: "#0094E6",
              emphasis: {
                lineStyle: {
                  color: "#0094E6",
                },
              },
              data: dataY ? dataY[1] : [],
            },
            {
              name: this.$t('fuelEfficientDriving.中等'),
              type: "line",
              smooth: true,
              color: "#DEAD00",
              emphasis: {
                lineStyle: {
                  color: "#DEAD00",
                },
              },
              data: dataY ? dataY[2] : [],
            },
            {
              name: this.$t('fuelEfficientDriving.一般'),
              type: "line",
              smooth: true,
              color: "#F57E00",
              emphasis: {
                lineStyle: {
                  color: "#F57E00",
                },
              },
              data: dataY ? dataY[3] : [],
            },
            {
              name: this.$t('fuelEfficientDriving.差'),
              type: "line",
              smooth: true,
              color: "#F22015",
              emphasis: {
                lineStyle: {
                  color: "#F22015",
                },
              },
              data: dataY ? dataY[4] : [],
            },
          ],
        };
      }

      this.chartLevel.setOption(option, true);
    },
    chartScoreSet(dataX, dataY) {
      let leftMax = 0;
      let rightMax = 0;
      if (dataY) {
        leftMax = Math.max(...dataY[0]);
        rightMax = Math.max(...dataY[1]);
      }
      var option = {
        grid: {
          left: 5,
          right: 5,
          bottom: 0,
          top: 55,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: [this.$t('fuelEfficientDriving.平均油耗'), this.$t('fuelEfficientDriving.平均得分')],
          // data: [this.$t("statistics.accumulatedMileage"), this.$t("statistics.accumulatedDuration")]
        },
        xAxis: [
          {
            type: "category",
            data: dataX ? dataX : [], //速度
            axisPointer: {
              type: "shadow",
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.$t('fuelEfficientDriving.平均油耗')+" L",
            min: 0,
            max: leftMax,
            interval: (leftMax - 0) / 4,
            splitNumber: 4,
          },
          {
            type: "value",
            name: this.$t('fuelEfficientDriving.平均得分'),
            min: 0,
            max: rightMax,
            interval: (rightMax - 0) / 4,
            splitNumber: 4,
          },
        ],
        series: [
          {
            name: this.$t('fuelEfficientDriving.平均油耗'),
            // type: 'bar',
            // barWidth:"15px",
            // stack: 'one',
            type: "line",
            smooth: true,
            color: "#FF8C00",
            tooltip: {
              valueFormatter: function (value) {
                return value + " L";
              },
            },
            data: dataY ? dataY[0] : [],
          },
          {
            name: this.$t('fuelEfficientDriving.平均得分'),
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            color: "#2A7AFF",
            tooltip: {
              valueFormatter: (value) => {
                return value + " "+this.$t('fuelEfficientDriving.分');
              },
            },
            emphasis: {
              lineStyle: {
                color: "#2A7AFF",
              },
            },
            data: dataY ? dataY[1] : [],
          },
        ],
      };
      this.chartScore.setOption(option);
    },
    setResize() {
      this.chartScore.resize();
      this.chartLevel.resize();
    },
  },
};
</script>
<style scoped lang="scss">
.boardsContain {
  flex: 1;
  // margin-top: 20px;
  height: 450px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #d9e4f8;
  padding: 20px 24px;
}
.contaiTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #0f1a3a;
}
.trendTypeFlex {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.trendType {
  height: 32px;
  width: 115px;
  border-radius: 1px;
  border: 1px solid #a2b1cb;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.trendIcon {
  height: 28px;
  width: 50%;
  border-radius: 1px;
  margin-left: 1px;
  display: grid;
  place-items: center;
}
.trendIcon1 {
  height: 28px;
  width: 50%;
  border-radius: 1px;
  margin-right: 1px;
  display: grid;
  place-items: center;
}
.dateRow{
  /* display: flex;justify-content: space-between; */
  display: grid;
  place-items: center;
  grid-template-columns: repeat(7, 1fr);
  font-weight: 400;
  font-size: 28px;
  color: #333333;
}
.dateGridOne{
  height: 45px;
  width: 45px;
  display: grid;
  place-items: center;
}
.dateContain{
  font-weight: 600;
}
.dateNum{
  width: 50px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #F1F1F1;
  border-radius: 8px;
  margin-top: 8px;
  position:relative;
}
.gridBottomText{
  position: absolute;
  bottom: 0%; 
  font-weight: 400;
  font-size: 15px;
}
</style>